import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CompanyDetailsSearchData} from "./company-details-search.data";

@Injectable()
export class CompanyDetailsSearchModel extends SearchModel<CompanyDetailsSearchData> {
    static readonly COMPANY_NAME_FILTER_NAME: string = "companyName";
    static readonly ABN_FILTER_NAME: string = "ABN";

    constructor(injector: Injector) {
        super(injector, CompanyDetailsSearchData);
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
